/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Filter } from '../../../model/Filter';
import { Command } from '../../../model/Command';
import { ListController } from '../../ListController';

class PreventiveSheetTemplateListController extends ListController {
    /** @ngInject */
    constructor(preventiveSheetTemplateService, waitSpinnerService, $q, $state, $stateParams, $log, notificationService,
        configuration, domainService, filterService, dialogService, $scope) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.domainService = domainService;
        this.preventiveSheetTemplateService = preventiveSheetTemplateService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$scope = $scope;
        // mdDataTable doesn't support ES6 syntax with $ctrl variable in templates. That's why we must attach the reload
        // callback to the scope with an arrow function so as it can be called by this component with the correct 'this'
        // binding.
        this.$scope.reload = () => this.reload();
        this.$log.debug('Controller \'PreventiveSheetTemplateList\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.paging.sort = 'name';
        this.commands = [];
        this.initFilters();

        this.handleRestServiceCall(this.loadFilters(), () => {
            this.initCommands();
            this.reload();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {
        this.domainFilter = Filter.equalFilterEmpty('domain.id', 'model.domain.domain', 'SELECT', []);

        this.filters.push(this.domainFilter, Filter.emptyLikeFilter('name', 'model.preventivesheettemplate.name'));
    }

    /**
     * Loads data in filters.
     */
    loadFilters() {
        return this.getFilterDomains();
    }

    /**
     * Gets the list of domains.
     *
     * @return {Object[]} Promise providing an array of domains.
     */
    getFilterDomains() {
        return this.filterService.getFilterOptions(this.domainService, this.domainFilter, 'name');
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        this.commands.push(
            Command.stateCommand('ui.preventivesheettemplate.create', 'images/svg/add.svg',
                'gmao.preventivesheet.template.create'),
            Command.handlerCommand(undefined, 'images/svg/reset.svg', () => this.reload())
        );
    }

    /**
     * Reloads the list of GRTs.
     *
     * @return {Promise} A promise providing the list of GRTs.
     */
    reload() {
        return this.handleRestServiceCall(
            this.preventiveSheetTemplateService.searchEntities({
                params: this.filterService.buildPagingParams(this.paging),
                data: this.filterService.buildFilters(this.filters)
            }),
            data => {
                this.model.data = data.content;
                this.model.totalElements = data.totalElements;
            }
        );
    }

    /**
     * Shows a confirmation dialog before deleting an preventiveSheet template. If the dialog is confirmed, the template
     * is deleted.
     *
     * @param {integer} id PreventiveSheet template ID.
     * @return {Promise} A promise containing the confirmation result.
     */
    showDeleteConfirmationDialog(id) {
        return this.dialogService.showConfirmationDialogWithMessage(
            'ui.preventivesheettemplate.deleteconfirmation'
        ).then(confirmed => {
            if (confirmed) {
                this.deletePreventiveSheetTemplate(id);
            }
            return confirmed;
        });
    }

    /**
     * Deletes immediately an preventiveSheet template without confirmation, and reloads the list of templates.
     *
     * @param {integer} id PreventiveSheet template ID.
     */
    deletePreventiveSheetTemplate(id) {
        return this.handleRestServiceCall(this.preventiveSheetTemplateService.deleteEntity(id), () => {
            this.notificationService.pushMessage('ui.preventivesheettemplate.deleted',
                this.configuration.NOTIFIER_LEVEL_INFO);
            this.reload();
        });
    }
}

export const preventiveSheetTemplateListComponent = {
    template: require('./preventivesheettemplate-list.html'),
    controller: PreventiveSheetTemplateListController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/component/PreventiveSheetTemplateList.js